import React from 'react';
import { NetworkEthereum, NetworkBinanceSmartChain, NetworkBase } from '@web3icons/react';
import './ChainIcon.css';

interface ChainIconProps {
    chain: string;
    size?: number;
    className?: string;
    showLabel?: boolean;
}

interface ChainConfig {
    icon: React.FC<any>;
    name: string;
    color: string;
}

const chainConfig: Record<string, ChainConfig> = {
    'eth': { icon: NetworkEthereum, name: 'Ethereum', color: '#627EEA' },
    'bnb': { icon: NetworkBinanceSmartChain, name: 'BNB Chain', color: '#F3BA2F' },
    'base': { icon: NetworkBase, name: 'Base', color: '#0000FF' },
    'robinhood': { icon: NetworkEthereum, name: 'Robinhood', color: '#00C805' },
};

export const ChainIcon: React.FC<ChainIconProps> = ({ chain, size = 24, className = '', showLabel = false }) => {
    const config = chainConfig[chain.toLowerCase()];

    if (!config) {
        return (
            <div className={`chain-icon-fallback ${className}`} title={chain}>
                <span className="chain-icon-text">{chain.substring(0, 3).toUpperCase()}</span>
            </div>
        );
    }

    const IconComponent = config.icon;

    return (
        <div
            className={`chain-icon-container ${className}`}
            title={config.name}
            style={{
                '--chain-color': config.color,
            } as React.CSSProperties}
        >
            <div className="chain-icon-wrapper">
                <div className="chain-icon-glow"></div>
                <IconComponent size={size} variant="branded" />
            </div>
            {showLabel && <span className="chain-icon-label">{config.name}</span>}
        </div>
    );
};
